'use client';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

import styles from './confirm-dialog.module.css';
import ButtonCommon from './button';

import { useConfirmDialog } from '@/hooks/use-confirm-dialog';

export default function ConfirmDialog() {
  const {
    open,
    title,
    content,
    confirmButtonText,
    cancelButtonText,
    handleConfirmDialog,
    handleClose,
    crossClose,
    isPositive,
    disableConfirmButton,
  } = useConfirmDialog();

  return (
    <Dialog
      open={open}
      onClose={crossClose ? undefined : handleClose} // if crossClose is true, prevent click outside to close
      scroll={'paper'}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      className={`${styles.dialog}`}
      disableScrollLock={true}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
          e.preventDefault();
        }
      }}
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: '#F9F9FF',
          borderRadius: '28px',
          maxWidth: '560px',
          minWidth: '280px',
        },
      }}
    >
      <DialogTitle id='alert-dialog-title' className={styles.dialogTitle}>
        {title}
        {crossClose && (
          <IconButton sx={{ padding: '4px' }} onClick={handleClose}>
            <CloseIcon sx={{ color: '#44474E' }} />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>{content}</DialogContent>
      <DialogActions className={styles.dialogActions}>
        {cancelButtonText && (
          <ButtonCommon variant={isPositive ? 'text' : 'contained'} onClick={handleClose}>
            {cancelButtonText}
          </ButtonCommon>
        )}
        <ButtonCommon
          variant={isPositive ? 'contained' : 'text'}
          onClick={handleConfirmDialog}
          disabled={!open || disableConfirmButton}
        >
          {confirmButtonText}
        </ButtonCommon>
      </DialogActions>
    </Dialog>
  );
}
